import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UtilsService {
  constructor() {}

  /**
   * Compara 2 fechas en el formato yyyy-MM-dd H:m y retorna true si
   * la fecha inicial es menor a la fecha final
   * @param date_start date in format yyyy-MM-dd H:m
   * @param date_end date in format yyyy-MM-dd H:m
   *
   * https://stackoverflow.com/questions/20322507/how-to-check-if-one-datetime-is-later-than-another-in-javascript
   */
  checkStartDateIsLessThanEndDate(date_start: string, date_end: string) {
    if (Date.parse(date_start) < Date.parse(date_end)) {
      // start is less than End
      return true;
    }
    // end is less than start
    return false;
  }
  /**
   * Formateo de fecha
   * @param date en Date
   * @returns Retorna la fecha en formato año-mes-dia (yyyy-MM-dd)
   */
  dateFormat(date: Date) {
    if (date) {
      let initYear = date.getFullYear();
      let initMonth = date.getMonth() + 1;
      let initDay = date.getDate();
      let init = initYear + '-' + this.legibleNumber(initMonth) + '-' + this.legibleNumber(initDay);
      let wi = formatDate(date, 'yyyy-MM-dd', 'en');
      console.log(init);

      console.log(wi);

      // console.log('SOY INIT ' + init);
      // return formatDate(date, 'yyyy-MM-dd', 'en');
      return init;
    }
  }

  /**
   * Conertir número legible
   */
  legibleNumber(num: number) {
    if (num < 10) {
      const x = num.toString();
      return `0${x}`;
    } else {
      return num;
    }
  }

  /**
   * Formateo de hora
   * @param date en Date
   * @returns Retorna la fecha Date reciba en formato Hora:minutos (H:m)
   */
  timeFormat(date: Date) {
    return formatDate(date, 'HH:mm', 'en');
  }
  /**
   * Transforma un string de fechas a Date
   * @param dateString La fecha en string en formato yyyy/MM/dd
   */
  stringToDate(dateString) {
    console.log(dateString);

    const datePattern = /^(\d{4})-(\d{2})-(\d{2})$/;
    const [, month, day, year] = datePattern.exec(dateString);
    const date = new Date(`${month}, ${day} ${year}`);
    return date;
  }
  /**
   * Debido a que la directiva formatea el precio con comas para
   * mejor legibilidad, se debe regresar a no tener comas y ser número
   * @param number Numero
   */
  numberRemoveCommas(number: number) {
    const numberChars = new RegExp('[^0-9]', 'g'); // match any characters except numbers
    return Number(number.toString().replace(numberChars, ''));
  }
}
